"use client"
import { useState, useEffect } from "react"
import {
  ChevronLeft,
  ChevronRight,
  Home,
  Package,
  Palette,
  Ruler,
  Plus,
  ShoppingCart,
  CreditCard,
  FileText,
  BarChart3,
  LogOut,
  User,
  LayoutDashboard,
  Tag,
  ShoppingBag,
  Wallet,
  Store,
  FilePlus,
  Building2,
  ArrowLeftRight,
  PlusCircle,
  ListChecks,
  Users,
  UserPlus,
  Receipt,
  Search,
  MessageSquareText,
} from "lucide-react"
import { Link, useNavigate } from "react-router-dom"

// Navigation data structure
const navigationData = {
  main: [
    {
      title: "Dashboard",
      url: "/dashboard",
      icon: LayoutDashboard,
      roles: ["admin"]
    },
    {
      title: "Purchases",
      url: "/all-purchases",
      icon: ShoppingCart,
      roles: ["admin"]
    },
    {
      title: "Products",
      url: "/all-products",
      icon: Package,
      roles: ["admin"]
    },


    {
      title: "Sales",
      url: "/all-sales",
      icon: ShoppingBag,
      roles: ["admin"]
    },
    {
      title: "Inventory",
      url: "/inventory",
      icon: Package,
      roles: ["admin"]
    },
    {
      title: "Dashboard",
      url: "/vendor-dashboard",
      icon: LayoutDashboard,
      roles: ["vendor"]
    },
    {
      title: "All Order",
      type: 'btn',
      url: "/all-vendor-order",
      icon: Package,
      roles: ["vendor"]
    },
    {
      title: "All Products",
      url: "/all-vendor-product",
      icon: Package,
      roles: ["vendor"]
    },

  ],
  manageInventory: [
    {
      title: "All Products",
      url: "/all-products",
      icon: Package,
    },
    {
      title: "Product Category",
      url: "/product-category",
      icon: Package,
    },
    {
      title: "Product Colours",
      url: "/product-color",
      icon: Palette,
    },
    {
      title: "Product Materials",
      url: "/product-materials",
      icon: Ruler,
    },
    {
      title: "Product Status",
      url: "/product-status",
      icon: Tag,
    },
    {
      title: "Add Product",
      url: "/add-product",
      icon: Plus,
    },
  ],
  sales: [
    {
      title: "All Sales",
      url: "/all-sales",
      icon: ShoppingCart,
    },
    // {
    //   title: "Add Sales",
    //   url: "/add-sale",
    //   icon: Plus,
    // },

  ],
  purchases: [
    {
      title: "All Vendors",
      url: "/all-vendors",
      icon: User,
    },
    {
      title: "All Purchases",
      url: "/all-purchases",
      icon: CreditCard,
    },
    {
      title: "Add Purchase",
      url: "/add-purchase",
      icon: Plus,
    },

  ],
  purchaseBill: [
    {
      title: "All Purchases Bill merchants",
      url: "/all-purchase-bill-merchants",
      icon: Store,
    },
    {
      title: "All Purchases Bill ",
      url: "/all-purchase-bill",
      icon: FileText,
    },
    {
      title: "Add Purchases Bill ",
      url: "/add-purchase-bill",
      icon: FilePlus,
    },
  ],
  Transactions: [
    {
      title: "All Transaction Merchant Names",
      url: "/all-transaction-merchant-name",
      icon: Building2,
    },
    {
      title: "All Transactions",
      url: "/all-transaction",
      icon: ArrowLeftRight,
    },
    {
      title: "Add Transaction ",
      url: "/add-transaction",
      icon: PlusCircle,
    },

  ],
  Leads: [
    {
      title: "All Lead Types",
      url: "/all-lead-type",
      icon: Tag,
    },

    {
      title: "All Lead Status",
      url: "/all-lead-status",
      icon: ListChecks,
    },
    {
      title: "All Leads",
      url: "/all-lead",
      icon: Users,
    },
    {
      title: "Add Leads",
      url: "/add-lead",
      icon: UserPlus,
    },
     {
      title: "Leads Looking For",
      url: "/all-lead-looking-for",
      icon: Search,
    },
     {
      title: "Lead Comments",
      url: "/all-lead-comments",
      icon: MessageSquareText,
    },

  ],
  Btobsales: [
    {
      title: "All Btobsales Customers",
      url: "/all-Btobsales-customers",
      icon: Users,
    },
     {
      title: "All Btobsales ",
      url: "/all-Btobsales",
      icon: Receipt,
    },
     {
      title: "Add Btobsales ",
      url: "/add-Btobsales",
      icon: PlusCircle,
    },


  ],
  reports: [
    {
      title: "Sales Report",
      url: "/sales-report",
      icon: BarChart3,
    },
    {
      title: "Purchase Report",
      url: "/purchase-report",
      icon: BarChart3,
    },
    {
      title: "Inventory Report",
      url: "/inventory-report",
      icon: BarChart3,
    },
  ],
  // users: [
  //   {
  //     title: "All Users",
  //     url: "/all-users",
  //     icon: User,
  //   },
  // ],
  settings: [
    {
      title: "Logout",
      type: 'btn',
      url: "/logout",
      icon: LogOut,
    },
  ],
  orders: [
    {
      title: "All Vendor Payments",
      type: 'btn',
      url: "/all-vendor-payments",
      icon: Wallet,
    },
    {
      title: "All Order Status",
      type: 'btn',
      url: "/all-order-status",
      icon: Tag,
    },
    {
      title: "All Courier Partner",
      type: 'btn',
      url: "/all-courier-partner",
      icon: User,
    },
    {
      title: "All Order Medium",
      type: 'btn',
      url: "/all-order-medium",
      icon: Ruler,
    },
    {
      title: "Add Order",
      type: 'btn',
      url: "/add-order",
      icon: Plus,
    },
    {
      title: "All Order",
      type: 'btn',
      url: "/all-order",
      icon: Package,
    },


  ]
}




const SideNavbar = ({ isCollapsed, setIsCollapsed }) => {
  const [activeItem, setActiveItem] = useState("/dashboard")
  const navigate = useNavigate()

  const [userRole, setUserRole] = useState(null)
  const personalInfo = JSON.parse(localStorage.getItem("personalInfo"));
  const companyName = personalInfo?.companyName || "company";


  useEffect(() => {
    const role = localStorage.getItem("userRole")
    if (role === "super" || role === "admin") {
      setUserRole("admin")
    }

    if (role === "vendor") {
      setUserRole("vendor")
    }

    const accessToken = localStorage.getItem("accessToken")
    if (!accessToken) {
      navigate("/login")
    }
  }, [navigate])

  const handleLogout = () => {
    localStorage.removeItem("accessToken")
    navigate("/login")
  }
  const filterByRole = (items) => items.filter(item => item.roles?.includes(userRole));

  return (
    <aside
      className={`fixed top-0 left-0 h-screen bg-white shadow-lg flex flex-col z-50 transition-all duration-300 ${isCollapsed ? "w-16" : "w-64"
        }`}
    >
      {/* Toggle Button */} 
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="absolute -right-3 top-6 bg-orange-500 text-white rounded-full p-1 shadow-lg hover:bg-orange-600 transition-colors z-10"
      >
        {isCollapsed ? <ChevronRight className="h-4 w-4" /> : <ChevronLeft className="h-4 w-4" />}
      </button>

      {/* Logo/Header */}
      <div className={`flex items-center gap-2 px-4 py-4 border-b ${isCollapsed ? "justify-center" : ""}`}>
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-orange-500 text-white flex-shrink-0">
          <Package className="h-4 w-4" />
        </div>
        {!isCollapsed && (
          <span className="font-semibold text-lg whitespace-nowrap overflow-hidden">{companyName}</span>
        )}
      </div>

      {/* Navigation */}
      <nav className="flex-1 overflow-y-auto py-4">
        {/* Main Section */}
        {!isCollapsed && <div className="mb-2 px-4 text-xs font-bold text-gray-500">Main</div>}
        {filterByRole(navigationData.main).map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* Manage Inventory Section */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Manage Inventory</div>}
        {userRole !== "vendor" && navigationData.manageInventory.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* orders Section */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Orders</div>}
        {userRole !== "vendor" && navigationData.orders.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* Purchases Section */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Purchases</div>}
        {userRole !== "vendor" && navigationData.purchases.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* Purchase bill Section */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Purchase Bills</div>}
        {userRole !== "vendor" && navigationData.purchaseBill.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* transaction Section */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Transactions</div>}
        {userRole !== "vendor" && navigationData.Transactions.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* Leads */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Leads</div>}
        {userRole !== "vendor" && navigationData.Leads.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* Btobsales */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">BtobSales</div>}
        {userRole !== "vendor" && navigationData.Btobsales.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* Sales Section */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Sales</div>}
        {userRole !== "vendor" && navigationData.sales.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}



        {/* Reports Section */}
        {!isCollapsed && userRole !== "vendor" && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Reports</div>}
        {userRole !== "vendor" && navigationData.reports.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
              } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))}

        {/* Users Section */}
        {/* {!isCollapsed && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Users</div>}
        {navigationData.users.map((item) => (
          <Link
            key={item.title}
            to={item.url}
            className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${
              activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
            } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
            onClick={() => setActiveItem(item.url)}
            title={isCollapsed ? item.title : ""}
          >
            <item.icon className="h-4 w-4 flex-shrink-0" />
            {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            {isCollapsed && (
              <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                {item.title}
              </div>
            )}
          </Link>
        ))} */}

        {/* Settings Section */}
        {!isCollapsed && <div className="mt-4 mb-2 px-4 text-xs font-bold text-gray-500">Settings</div>}
        {navigationData.settings.map((item) => (
          item.type === 'btn' ? (
            <button
              key={item.title}
              onClick={handleLogout}
              className={`w-full  flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
                } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
              title={isCollapsed ? item.title : ""}
            >
              <item.icon className="h-4 w-4 flex-shrink-0" />
              {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
            </button>
          ) : (
            <Link
              key={item.title}
              to={item.url}
              className={`flex items-center gap-2 py-2 hover:bg-orange-100 transition-colors text-sm group relative ${activeItem === item.url ? "bg-orange-50 text-orange-600 font-semibold" : "text-gray-700"
                } ${isCollapsed ? "px-4 justify-center" : "px-6"}`}
              onClick={() => setActiveItem(item.url)}
              title={isCollapsed ? item.title : ""}
            >
              <item.icon className="h-4 w-4 flex-shrink-0" />
              {!isCollapsed && <span className="whitespace-nowrap">{item.title}</span>}
              {isCollapsed && (
                <div className="absolute left-full ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50">
                  {item.title}
                </div>
              )}
            </Link>
          )
        ))}

      </nav>
    </aside>
  )
}

export default SideNavbar
